import { VbzButton, VbzModal } from '@smiles/voebiz-ui-kit';
import React, { FC } from 'react';
import { ModalBody } from 'reactstrap';

interface ErrorModalProps {
  isOpen: boolean;
  onClosed: () => void;
  reOpenFormModal: () => void;
}

const ErrorModal: FC<ErrorModalProps> = ({ isOpen, onClosed, reOpenFormModal }) => {
  return (
    <VbzModal isOpen={isOpen} type="right" desktopSize="small" toggle={onClosed}>
      <ModalBody>
        <div className="modal-title">
          <h3>Não foi possível enviar sua solicitação</h3>
        </div>
        <div className="modal-description">
          <p>
            Verifique se os dados estão corretos e se os pontos deste voo já foram acumulados anteriormente. Para
            maiores informações entre em contato conosco através do formulário de atendimento.
          </p>
        </div>
        <div className="vbz-button-submit">
          <VbzButton
            id="submit-modal"
            className="mt-5 smls-register-cpf upgrade-modal-button"
            color="primary"
            text="Tentar de novo"
            onClick={() => {
              reOpenFormModal();
              onClosed();
            }}
          />
        </div>
        <VbzButton
          className="voebiz-register-hyperlink"
          color="hyperlink"
          text="Voltar para o início"
          onClick={onClosed}
        />
      </ModalBody>
    </VbzModal>
  );
};

export default ErrorModal;
